var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99989 0C3.17426 0 1.57779 0.978438 0.704899 2.4395C0.533724 2.72629 0.653512 3.0985 0.959404 3.23218C1.21495 3.34398 1.51425 3.24885 1.6573 3.00962C1.82083 2.73636 2.01909 2.48116 2.24998 2.25027C2.98433 1.51592 3.96104 1.11142 4.99989 1.11142C6.03874 1.11142 7.0151 1.51592 7.74979 2.25027C8.48414 2.98462 8.88864 3.96132 8.88864 5.00017C8.88864 6.03903 8.48414 7.01538 7.74979 7.75008C7.01544 8.48443 6.03874 8.88893 4.99989 8.88893C4.25269 8.88893 3.53779 8.67956 2.92218 8.28895L3.19335 8.10354C3.43085 7.94104 3.40342 7.58238 3.1437 7.45773L1.20905 6.52998C0.949682 6.40568 0.652817 6.6088 0.674692 6.89559L0.838575 9.0351C0.860449 9.3219 1.18509 9.47745 1.42258 9.31495L1.94479 8.95767C2.7899 9.61078 3.84958 10 5.00024 10C7.74285 10 9.96986 7.79174 9.99971 5.05607C10.0296 2.29714 7.75847 0 4.99989 0Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99963 2.18744C4.69269 2.18744 4.44409 2.43604 4.44409 2.74298V4.96963C4.44409 5.1363 4.51041 5.29601 4.62811 5.41406L5.77634 6.56229C5.99334 6.77929 6.34507 6.77929 6.56207 6.56229C6.77908 6.34528 6.77908 5.99356 6.56207 5.77655L5.73919 4.95366C5.62148 4.83596 5.55516 4.67589 5.55516 4.50923V2.74298C5.55516 2.43604 5.30656 2.18744 4.99963 2.18744Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.624978 4.99983C0.970144 4.99983 1.24996 4.72002 1.24996 4.37486C1.24996 4.02969 0.970144 3.74988 0.624978 3.74988C0.279812 3.74988 0 4.02969 0 4.37486C0 4.72002 0.279812 4.99983 0.624978 4.99983Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastIcon);
export default __webpack_public_path__ + "static/media/LastIcon.e7cadf8732592d5df7aaeac0a7c98c9e.svg";
export { ForwardRef as ReactComponent };